import {
  ChartDrilldownSelection,
  CoverageReportChartSeries,
  SovReportChartPeriod,
} from 'app/interfaces';

export interface AlignedPieChartData {
  labels: string[];
  queries: string[];
  series: number[];
  drilldowns: Array<ChartDrilldownSelection | undefined>;
}

/**
 * Keeps pie entries in the same order as the timeline series. The chart API can
 * omit zero-value pie entries, which would otherwise shift every later color.
 * Pie-only entries, such as intersection buckets, remain at the end.
 */
export function alignPieChartData(
  pie: SovReportChartPeriod,
  timelineSeries: CoverageReportChartSeries[]
): AlignedPieChartData {
  const pieLabels = pie?.labels || [];
  const usedPieIndexes = new Set<number>();
  const aligned: AlignedPieChartData = {
    labels: [],
    queries: [],
    series: [],
    drilldowns: [],
  };

  const appendPieEntry = (index: number) => {
    aligned.labels.push(pieLabels[index]);
    aligned.queries.push(pie?.queries?.[index] || '');
    aligned.series.push(Number(pie?.series?.[index] || 0));
    aligned.drilldowns.push(pie?.drilldowns?.[index]);
  };

  (timelineSeries || []).forEach((timelineEntry) => {
    const pieIndex = pieLabels.findIndex(
      (label, index) =>
        !usedPieIndexes.has(index) && label === timelineEntry.name
    );

    if (pieIndex >= 0) {
      usedPieIndexes.add(pieIndex);
      appendPieEntry(pieIndex);
      return;
    }

    aligned.labels.push(timelineEntry.name);
    aligned.queries.push(timelineEntry.query || '');
    aligned.series.push(0);
    aligned.drilldowns.push(timelineEntry.drilldown);
  });

  pieLabels.forEach((_label, index) => {
    if (!usedPieIndexes.has(index)) {
      appendPieEntry(index);
    }
  });

  return aligned;
}
